/* Souperstar "Include cutlery" cart tick-box (PREVIEW ONLY, 2 Nov 2026, Rae 9:57 PM SGT).
   One tick-box on the cart page (under the Souper Points line) and in the cart drawer (under the items).
   Ticked -> cart attribute "Cutlery: Yes" (shows on the order under Additional details, the packing slip and the WhatsApp slip).
   Unticked -> attribute cleared. State comes from /cart.js, so it survives reloads and stays in sync between drawer and page.
   No price wording (no cutlery price exists in the store). Not tied to group orders: in a group order the organiser ticks it.
   Roll back: remove {% render 'ss-cutlery' %} from layout/theme.liquid. */
(function () {
  if (window.SSCutlery) return;
  var KEY = 'Cutlery', root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', state = null, saving = false;
  var nf = window.fetch.bind(window);
  function getCart() { return nf(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function paint() { document.querySelectorAll('[data-ss-cutlery] input').forEach(function (i) { i.checked = state === true; i.disabled = saving; }); }
  function save(on) {
    saving = true; state = on; paint();
    var a = {}; a[KEY] = on ? 'Yes' : '';
    return nf(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: a }) })
      .then(function (r) { return r.json(); }).then(function (c) { state = (c.attributes || {})[KEY] === 'Yes'; })
      .catch(function () { state = !on; }).then(function () { saving = false; paint(); });
  }
  function box(id) {
    var d = document.createElement('div'); d.className = 'ss-cut'; d.setAttribute('data-ss-cutlery', '');
    d.innerHTML = '<label class="ss-cut__l" for="' + id + '"><input type="checkbox" id="' + id + '"><span>Include cutlery</span></label>';
    d.querySelector('input').addEventListener('change', function () { save(this.checked); });
    return d;
  }
  function inject() {
    var page = document.querySelector('#CartPageForm [data-ss-pts]');
    if (page && !document.getElementById('SSCutleryPage')) { var b = box('SSCutleryPage'); page.parentNode.insertBefore(b, page.nextSibling); }
    var dr = document.querySelector('#CartDrawerForm [data-products]');
    if (dr && !document.getElementById('SSCutleryDrawer')) { var c = box('SSCutleryDrawer'); dr.parentNode.insertBefore(c, dr.nextSibling); }
    if (state !== null) paint();
  }
  var css = '.ss-cut{margin:10px 0 12px}.ss-cut__l{display:flex;align-items:center;gap:10px;min-height:44px;padding:8px 12px;border:1px solid #e5ddd5;border-radius:8px;background:#fff;font-size:15px;cursor:pointer;margin:0}' +
    '.ss-cut__l input{width:20px;height:20px;margin:0;flex:0 0 auto;accent-color:#1f1a17}.ss-cut__l span{text-transform:none;letter-spacing:0;font-weight:500}' +
    '#CartDrawerForm .ss-cut{margin:12px 0}';
  var s = document.createElement('style'); s.textContent = css; document.head.appendChild(s);
  function start() {
    inject();
    new MutationObserver(function () { inject(); }).observe(document.body, { childList: true, subtree: true });
    getCart().then(function (c) { state = (c.attributes || {})[KEY] === 'Yes'; paint(); }).catch(function () {});
    document.addEventListener('cart:updated', function () { getCart().then(function (c) { if (!saving) { state = (c.attributes || {})[KEY] === 'Yes'; paint(); } }); });
  }
  window.SSCutlery = { get: function () { return state; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
